import { defineStore } from 'pinia';
import { useStorage, StorageSerializers } from '@vueuse/core';

export enum ListViewMode {
    Table = 'table',
    Card = 'card',
}

export const useListViewModeStore = defineStore('list-view-mode', () => {
    const mode = useStorage<ListViewMode>('list-view-mode', ListViewMode.Card, localStorage, {
        mergeDefaults: true,
        serializer: StorageSerializers.string,
    });

    return { mode };
});
